import { createStore } from 'satcheljs';
import { CalendarPublishingStore } from './schema/CalendarPublishingStore';
import '../mutators/saveCalendarPublishingPermissionsMutator';
import '../mutators/updatePublishSelectedCalendarMutator';
import '../mutators/initializeCalendarPublishingPermissionStoreMutator';
import '../mutators/updateSelectedPublishingPermissionMutator';
import '../mutators/setCalendarPublishingCalendarErrorMutator';
import '../mutators/setCalendarPublishingErrorStateErrorMutator';
import '../mutators/setCreatePublishingPermissionPendingMutator';
import '../mutators/setInitialPublishPermissionsPendingMutator';
import '../mutators/setLinkResetPendingMutator';
import '../mutators/setUnpublishPendingMutator';

import '../orchestrators/unpublishPublishedCalendarOrchestrator';
import '../orchestrators/createNewCalendarPublishingPermissionOrchestrator';

let initialCalendarPublishingStoreData: CalendarPublishingStore = {
    viewState: null,
};

export default createStore<CalendarPublishingStore>(
    'CalendarPublishingStore',
    initialCalendarPublishingStoreData
);
